const ITEMS = [
  "DIGITAL REVOLUTION RADIO",
  "★",
  "NOW BROADCASTING",
  "★",
  "HARD ROCK / HEAVY METAL",
  "★",
  "TURN IT UP",
  "★",
  "NO ALGORITHM. NO ADS.",
  "★",
  "PURE SIGNAL",
  "★",
  "24 / 7",
  "★",
];

export default function Ticker() {
  const line = [...ITEMS, ...ITEMS].join("   //   ");
  return (
    <div
      className="border-b border-zinc-800 bg-red-600 text-black overflow-hidden"
      data-testid="ticker"
    >
      <div className="whitespace-nowrap py-2 font-display tracking-widest text-sm">
        <span className="ticker inline-block pr-12">{line}</span>
        <span className="ticker inline-block pr-12" aria-hidden>
          {line}
        </span>
      </div>
    </div>
  );
}
